import 'css-chunk-1JavaScriptSource/components/_Dialogs/svg-source-editor/style.module.scss';export default {
  "dialog": "_dialog_4fy7h_1",
  "container": "_container_4fy7h_6",
  "editorContainer": "_editorContainer_4fy7h_22",
  "buttonList": "_buttonList_4fy7h_28"
};